// src/components/HotelCards.js
import React, { useState, useEffect } from 'react';
import './HotelCards.css';
import InfoCard from './InfoCard';
import ImageCard from './ImageCard';

import cardIcon1 from '../../Assets/Images/cardIcon1.svg'; 
import cardIcon2 from '../../Assets/Images/cardIcon2.svg'; 
import cardIcon3 from '../../Assets/Images/cardIcon3.svg'; 

// Load Services
import { fetchImagesFromAPI } from '../../Services/RandomImageService'; // ajuste o caminho


const HotelCards = (props) => {


    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [imageArray, setImageArray] = React.useState([]);
    const [imageCredits, setImageCredits] = React.useState([]);

  React.useEffect(() => {
    fetchImagesFromAPI('turismo', 8, setImageArray, setImageCredits);
  }, []);

    return (
        <div className="hotel-cards">
            <div className="image-cards">
                <div className="image-row">
                    <ImageCard image={imageArray[0]} />
                    <ImageCard image={imageArray[1]} />
                </div>
                <div className="image-row">
                    <ImageCard image={imageArray[2]} />
                    <ImageCard image={imageArray[3]} />
                </div>
            </div>
            <div className="info-cards">
                <InfoCard icon={cardIcon1} text={(<><div style={{textAlign:"left"}}>Hotéis 4 estrelas</div><small style={{textAlign:"left"}}>selecionados criteriosamente pela qualidade</small></>)}  mousePosition={mousePosition} />
                <InfoCard icon={cardIcon2} text={(<><div style={{textAlign:"left"}}>Avaliação mínima de 8</div><small style={{textAlign:"left"}}>nas principais empresas de venda online de hotéis</small></>)} extraClass="displaced" mousePosition={mousePosition} />
                <InfoCard icon={cardIcon3} text={(<><div style={{textAlign:"left"}}>Localização estratégica</div><small style={{textAlign:"left"}}>perto de locais que realmente importam</small></>)} mousePosition={mousePosition} />
            </div>
        </div>
    );
};

export default HotelCards;
